// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../statics/collect_edit.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../statics/collect_edit_hover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../statics/collect_edit_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../statics/collect_delete.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../statics/collect_delete_hover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../statics/collect_delete_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../../statics/collect_more.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../../statics/collect_more_hover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../../statics/collect_more_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../../../statics/collect_mark.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../../../statics/collect_mark_hover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../../../statics/collect_mark_active.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShowBox_container__QsIUh {

}

.ShowBox_main__HeYYw {
    width: 100%;
    height: calc(100% - 217px);
    padding-bottom: 20px;
}

.ShowBox_filter_box__UX1j5 {
    /* margin-top: 5px; */
}

.ShowBox_filter_title__O3PMc {
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    font-size: 20px;
    color: #4f4f4f;
    margin-bottom: 16px;
}

.ShowBox_filter_box__UX1j5:not(:first-child) .ShowBox_filter_title__O3PMc {
    margin-top: 36px;
}

.ShowBox_filter_hint__QnrzL {
    margin: 16px 0;
    font-size: 14px;
    font-family: 'PingFangSCMedium';
    color: #7e8b9e;
    cursor: default;
}

.ShowBox_list_box__3kuPG {

}

.ShowBox_list_item_box__BHcGj {
    border: 1px solid #cbd1d8;
    transition: box-shadow 0.5s;
}

.ShowBox_list_item_box__BHcGj:hover {
    box-shadow:0px 4px 4px rgba(0, 0, 0, 0.25);
}

.ShowBox_list_item__NTJGq {
    width: 100%;
    height: 56px;
    padding: 0 15px;
    overflow: hidden; /* 隐藏溢出的内容 */
    transition: height 0.4s;
}

.ShowBox_list_item_open__YZ9QM {
    height: 112px;
    transition: height 0.4s;
}

.ShowBox_list_item_box__BHcGj:not(:last-child) {
    border-bottom: none;
}

.ShowBox_list_box__3kuPG .ShowBox_list_item_box__BHcGj:first-child {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
}

.ShowBox_list_box__3kuPG .ShowBox_list_item_box__BHcGj:not(:first-child):last-child {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
}

.ShowBox_item_top__mtPK2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 56px;
}

.ShowBox_vector_box__3rC0c,
.ShowBox_vector_open_box__SyLZ- {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 20px;
    height: 20px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.ShowBox_vector_open_box__SyLZ- {
    justify-content: center;
}

/* .vector_box:hover {
    background-color: #c6e0e4;
}

.vector_box:active {
    background-color: #17a8b5;
} */

.ShowBox_vector_drag__2uaTU {
    width: 17px;
    height: 6px;
}

.ShowBox_vector_message__ptitK {
    width: 14px;
    height: 14px;
}

.ShowBox_vector_open__F6RiG {
    width: 11px;
    height: 6px;
}

.ShowBox_abstract_box__g0VSy {
    width: 70%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.ShowBox_abstract__-isLY {
    width: 100%;
    height: 100%;
    font-family: 'PingFangSCMedium';
    font-size: 16px;
    color: #4f4f4f;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.ShowBox_tool_box__6EZDO {
    display: flex;
    justify-content: flex-end;
    width: 24%;
}

.ShowBox_tool_enter__3I5tz,
.ShowBox_tool_delete__cqABH,
.ShowBox_tool_collect__zQMg-,
.ShowBox_tool_more__qfP8N {
    width: 32px;
    height: 32px;
    cursor: pointer;
    border-radius: 32px;
    transition: background 0.5s, box-shadow 0.5s;
    margin-right: 6px;
}

.ShowBox_tool_enter__3I5tz {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center / 100% 100%;
}

/* 隐藏伪元素用来预加载悬停背景图 */
.ShowBox_tool_enter__3I5tz::before {
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center / 100% 100%;
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
}

.ShowBox_tool_enter__3I5tz::after {
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center / 100% 100%;
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
}

.ShowBox_tool_enter__3I5tz:hover {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center / 100% 100%;
    box-shadow:0px 5px 10px #ddd;
}

.ShowBox_tool_enter__3I5tz:active {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center / 100% 100%;
    box-shadow:0px 5px 10px #ddd;
}

.ShowBox_tool_delete__cqABH {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center / 100% 100%;
}

/* 隐藏伪元素用来预加载悬停背景图 */
.ShowBox_tool_delete__cqABH::before {
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center / 100% 100%;
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
}

.ShowBox_tool_delete__cqABH::after {
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat center / 100% 100%;
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
}

.ShowBox_tool_delete__cqABH:hover {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center / 100% 100%;
    box-shadow:0px 5px 10px #ddd;
}

.ShowBox_tool_delete__cqABH:active {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat center / 100% 100%;
    box-shadow:0px 5px 10px #ddd;
}

.ShowBox_tool_more__qfP8N {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat center / 100% 100%;
}

/* 隐藏伪元素用来预加载悬停背景图 */
.ShowBox_tool_more__qfP8N::before {
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat center / 100% 100%;
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
}

.ShowBox_tool_more__qfP8N::after {
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat center / 100% 100%;
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
}

.ShowBox_tool_more__qfP8N:hover {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat center / 100% 100%;
    box-shadow:0px 5px 10px #ddd;
}

.ShowBox_tool_more__qfP8N:active {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat center / 100% 100%;
    box-shadow:0px 5px 10px #ddd;
}

.ShowBox_time__vGPoZ {
    width: 100%;
    text-align: end;
    font-size: 14px;
    font-family: 'PingFangSCMedium';
    color: #7e8b9e;
}

.ShowBox_item_bottom__hBj1X {
    display: flex;
    width: 100%;
    height: 56px;
    border-top: 1px solid #cbd1d8;
}

.ShowBox_model_box__7NzZa {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 50%;
    height: 100%;
}

.ShowBox_model_img__cvOZl {
    width: 28px;
    height: 28px;
    margin-right: 16px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    font-size: 14px;
    color: #4f4f4f;
}

.ShowBox_model_name__g-2Rv {
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    font-size: 14px;
    color: #4f4f4f;
}

.ShowBox_num_box__cf-hW {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 50%;
    height: 100%;
}

.ShowBox_text_box__j0Bwv {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* width: 110px; */
}

.ShowBox_text_box__j0Bwv:not(:last-child) {
    margin-right: 25px;
}

.ShowBox_text_title__TYHEq {
    font-family: 'PingFangSCMedium';
    font-size: 14px;
    color: #7e8b9e;
    margin-right: 10px;
}

.ShowBox_text_img__8voWM {
    width: 24px;
    height: 24px;
    margin-right: 10px;
}

.ShowBox_num__Owj7- {

}

.ShowBox_popover_box__IEDdg {

}

.ShowBox_popover_item__ZLax0 {
    width: 140px;
    height: 40px;
}

.ShowBox_popover_item__ZLax0 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 10px;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.5s;
}

.ShowBox_popover_item__ZLax0:hover {
    background-color: #dfdfdf;
}

.ShowBox_popover_item__ZLax0:active {
    background-color: #cdcdcd;
}

.ShowBox_popover_butn_img__Rrds8 {
    width: 16px;
    height: 16px;
    margin-right: 10px;
}

.ShowBox_popover_item_text__qpPil {
    font-size: 14px;
}

.custom_popover_collect .ant-popover-content .ant-popover-inner {
    padding: 5px;
}

.ShowBox_tool_collect__zQMg- {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat center / 100% 100%;
}

/* 隐藏伪元素用来预加载悬停背景图 */
.ShowBox_tool_collect__zQMg-::before {
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat center / 100% 100%;
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
}

.ShowBox_tool_collect__zQMg-::after {
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat center / 100% 100%;
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
}

.ShowBox_tool_collect__zQMg-:hover {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat center / 100% 100%;
    box-shadow:0px 5px 10px #ddd;
}

.ShowBox_tool_collect__zQMg-:active {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat center / 100% 100%;
    box-shadow:0px 5px 10px #ddd;
}

.ShowBox_ask_abstract_box__iOG1d {
    width: 70%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

/* .ask_abstract {
    width: 100%;
    height: 100%;
    font-family: 'PingFangSCMedium';
    font-size: 16px;
    color: #4f4f4f;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
} */

.ShowBox_ask_list_item__12EoS {
    width: 100%;
    /* min-height: 56px; */
    padding: 15px;
    /* overflow: hidden; */
    overflow: visible;
    transition: height 0.4s;
}

.ShowBox_ask_item_top__3qpJn {
    display: flex;
    align-items: flex-start;
    width: 100%;
}

.ShowBox_ask_item_top_open__JujVB {
    align-items: flex-start;
}

.ShowBox_ask_vector_box__TQwJi,
.ShowBox_ask_vector_open_box__GLoXh {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 32px;
    height: 42px;
    cursor: pointer;
    transition: background-color 0.3s;
    flex-shrink: 0; /* 防止被压缩 */
    padding-top: 10px;
}

.ShowBox_ask_model_img__jQcCJ {
    width: 28px;
    height: 28px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    font-size: 14px;
    color: #4f4f4f;
    flex-shrink: 0; /* 防止被压缩 */
}

.ShowBox_ask_vector_open_box__GLoXh {
    justify-content: flex-end;
    align-items: flex-start;
}

.ShowBox_ask_tool_box__lAoHL {
    display: flex;
    justify-content: flex-end;
    width: 24%;
    flex-shrink: 0; /* 防止被压缩 */
    padding-top: 10px;
}

.ShowBox_ask_abstract__VZILU {
    max-height: 60px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* 限制显示两行 */
    -webkit-box-orient: vertical;
    text-overflow: ellipsis; /* 超出部分显示省略号 */
    flex-grow: 1;
    transition: max-height .3s ease;
}

.ShowBox_ask_abstract__VZILU.ShowBox_expanded__BqWR3 {
  -webkit-line-clamp: unset; /* 取消行数限制 */
  max-height: none;
    white-space: normal;
}

.ShowBox_ask_abstract__VZILU.ShowBox_collapsed__83Vyx {
    display: -webkit-box;
    -webkit-line-clamp: 2; /* 限制显示两行 */
    -webkit-box-orient: vertical;
    text-overflow: ellipsis; /* 超出部分显示省略号 */
}`, "",{"version":3,"sources":["webpack://./src/pages/collect/components/ShowBox/index.module.css"],"names":[],"mappings":"AAAA;;AAEA;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,+BAA+B;IAC/B,cAAc;IACd,eAAe;AACnB;;AAEA;;AAEA;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB,EAAE,YAAY;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;;;;;GAMG;;AAEH;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,UAAU;IACV,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,eAAe;IACf,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,UAAU;AACd;;AAEA;;;;IAII,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,4CAA4C;IAC5C,iBAAiB;AACrB;;AAEA;IACI,gFAAoF;AACxF;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,gFAA0F;IAC1F,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gFAA2F;IAC3F,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gFAA0F;IAC1F,4BAA4B;AAChC;;AAEA;IACI,gFAA2F;IAC3F,4BAA4B;AAChC;;AAEA;IACI,gFAAsF;AAC1F;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,gFAA4F;IAC5F,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gFAA6F;IAC7F,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gFAA4F;IAC5F,4BAA4B;AAChC;;AAEA;IACI,gFAA6F;IAC7F,4BAA4B;AAChC;;AAEA;IACI,gFAAoF;AACxF;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,gFAA0F;IAC1F,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gFAA2F;IAC3F,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gFAA0F;IAC1F,4BAA4B;AAChC;;AAEA;IACI,gFAA2F;IAC3F,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gFAAoF;AACxF;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,iFAA0F;IAC1F,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iFAA2F;IAC3F,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,iFAA0F;IAC1F,4BAA4B;AAChC;;AAEA;IACI,iFAA2F;IAC3F,4BAA4B;AAChC;;AAEA;IACI,UAAU;IACV,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;;;;;;;;GASG;;AAEH;IACI,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iCAAiC;IACjC,cAAc,EAAE,UAAU;IAC1B,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,cAAc,EAAE,UAAU;AAC9B;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,UAAU;IACV,cAAc,EAAE,UAAU;IAC1B,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB,EAAE,WAAW;IAClC,4BAA4B;IAC5B,uBAAuB,EAAE,cAAc;IACvC,YAAY;IACZ,+BAA+B;AACnC;;AAEA;EACE,yBAAyB,EAAE,WAAW;EACtC,gBAAgB;IACd,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB,EAAE,WAAW;IAClC,4BAA4B;IAC5B,uBAAuB,EAAE,cAAc;AAC3C","sourcesContent":[".container {\n\n}\n\n.main {\n    width: 100%;\n    height: calc(100% - 217px);\n    padding-bottom: 20px;\n}\n\n.filter_box {\n    /* margin-top: 5px; */\n}\n\n.filter_title {\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    font-size: 20px;\n    color: #4f4f4f;\n    margin-bottom: 16px;\n}\n\n.filter_box:not(:first-child) .filter_title {\n    margin-top: 36px;\n}\n\n.filter_hint {\n    margin: 16px 0;\n    font-size: 14px;\n    font-family: 'PingFangSCMedium';\n    color: #7e8b9e;\n    cursor: default;\n}\n\n.list_box {\n\n}\n\n.list_item_box {\n    border: 1px solid #cbd1d8;\n    transition: box-shadow 0.5s;\n}\n\n.list_item_box:hover {\n    box-shadow:0px 4px 4px rgba(0, 0, 0, 0.25);\n}\n\n.list_item {\n    width: 100%;\n    height: 56px;\n    padding: 0 15px;\n    overflow: hidden; /* 隐藏溢出的内容 */\n    transition: height 0.4s;\n}\n\n.list_item_open {\n    height: 112px;\n    transition: height 0.4s;\n}\n\n.list_item_box:not(:last-child) {\n    border-bottom: none;\n}\n\n.list_box .list_item_box:first-child {\n    border-top-left-radius: 6px;\n    border-top-right-radius: 6px;\n}\n\n.list_box .list_item_box:not(:first-child):last-child {\n    border-bottom-left-radius: 6px;\n    border-bottom-right-radius: 6px;\n}\n\n.item_top {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: 56px;\n}\n\n.vector_box,\n.vector_open_box {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: 20px;\n    height: 20px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.vector_open_box {\n    justify-content: center;\n}\n\n/* .vector_box:hover {\n    background-color: #c6e0e4;\n}\n\n.vector_box:active {\n    background-color: #17a8b5;\n} */\n\n.vector_drag {\n    width: 17px;\n    height: 6px;\n}\n\n.vector_message {\n    width: 14px;\n    height: 14px;\n}\n\n.vector_open {\n    width: 11px;\n    height: 6px;\n}\n\n.abstract_box {\n    width: 70%;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n.abstract {\n    width: 100%;\n    height: 100%;\n    font-family: 'PingFangSCMedium';\n    font-size: 16px;\n    color: #4f4f4f;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n.tool_box {\n    display: flex;\n    justify-content: flex-end;\n    width: 24%;\n}\n\n.tool_enter,\n.tool_delete,\n.tool_collect,\n.tool_more {\n    width: 32px;\n    height: 32px;\n    cursor: pointer;\n    border-radius: 32px;\n    transition: background 0.5s, box-shadow 0.5s;\n    margin-right: 6px;\n}\n\n.tool_enter {\n    background: url('../../../../statics/collect_edit.png') no-repeat center / 100% 100%;\n}\n\n/* 隐藏伪元素用来预加载悬停背景图 */\n.tool_enter::before {\n    content: \"\";\n    background: url('../../../../statics/collect_edit_hover.png') no-repeat center / 100% 100%;\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    z-index: -1;\n}\n\n.tool_enter::after {\n    content: \"\";\n    background: url('../../../../statics/collect_edit_active.png') no-repeat center / 100% 100%;\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    z-index: -1;\n}\n\n.tool_enter:hover {\n    background: url('../../../../statics/collect_edit_hover.png') no-repeat center / 100% 100%;\n    box-shadow:0px 5px 10px #ddd;\n}\n\n.tool_enter:active {\n    background: url('../../../../statics/collect_edit_active.png') no-repeat center / 100% 100%;\n    box-shadow:0px 5px 10px #ddd;\n}\n\n.tool_delete {\n    background: url('../../../../statics/collect_delete.png') no-repeat center / 100% 100%;\n}\n\n/* 隐藏伪元素用来预加载悬停背景图 */\n.tool_delete::before {\n    content: \"\";\n    background: url('../../../../statics/collect_delete_hover.png') no-repeat center / 100% 100%;\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    z-index: -1;\n}\n\n.tool_delete::after {\n    content: \"\";\n    background: url('../../../../statics/collect_delete_active.png') no-repeat center / 100% 100%;\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    z-index: -1;\n}\n\n.tool_delete:hover {\n    background: url('../../../../statics/collect_delete_hover.png') no-repeat center / 100% 100%;\n    box-shadow:0px 5px 10px #ddd;\n}\n\n.tool_delete:active {\n    background: url('../../../../statics/collect_delete_active.png') no-repeat center / 100% 100%;\n    box-shadow:0px 5px 10px #ddd;\n}\n\n.tool_more {\n    background: url('../../../../statics/collect_more.png') no-repeat center / 100% 100%;\n}\n\n/* 隐藏伪元素用来预加载悬停背景图 */\n.tool_more::before {\n    content: \"\";\n    background: url('../../../../statics/collect_more_hover.png') no-repeat center / 100% 100%;\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    z-index: -1;\n}\n\n.tool_more::after {\n    content: \"\";\n    background: url('../../../../statics/collect_more_active.png') no-repeat center / 100% 100%;\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    z-index: -1;\n}\n\n.tool_more:hover {\n    background: url('../../../../statics/collect_more_hover.png') no-repeat center / 100% 100%;\n    box-shadow:0px 5px 10px #ddd;\n}\n\n.tool_more:active {\n    background: url('../../../../statics/collect_more_active.png') no-repeat center / 100% 100%;\n    box-shadow:0px 5px 10px #ddd;\n}\n\n.time {\n    width: 100%;\n    text-align: end;\n    font-size: 14px;\n    font-family: 'PingFangSCMedium';\n    color: #7e8b9e;\n}\n\n.item_bottom {\n    display: flex;\n    width: 100%;\n    height: 56px;\n    border-top: 1px solid #cbd1d8;\n}\n\n.model_box {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: 50%;\n    height: 100%;\n}\n\n.model_img {\n    width: 28px;\n    height: 28px;\n    margin-right: 16px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    font-size: 14px;\n    color: #4f4f4f;\n}\n\n.model_name {\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    font-size: 14px;\n    color: #4f4f4f;\n}\n\n.num_box {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    width: 50%;\n    height: 100%;\n}\n\n.text_box {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    /* width: 110px; */\n}\n\n.text_box:not(:last-child) {\n    margin-right: 25px;\n}\n\n.text_title {\n    font-family: 'PingFangSCMedium';\n    font-size: 14px;\n    color: #7e8b9e;\n    margin-right: 10px;\n}\n\n.text_img {\n    width: 24px;\n    height: 24px;\n    margin-right: 10px;\n}\n\n.num {\n\n}\n\n.popover_box {\n\n}\n\n.popover_item {\n    width: 140px;\n    height: 40px;\n}\n\n.popover_item {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    padding-left: 10px;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: background 0.5s;\n}\n\n.popover_item:hover {\n    background-color: #dfdfdf;\n}\n\n.popover_item:active {\n    background-color: #cdcdcd;\n}\n\n.popover_butn_img {\n    width: 16px;\n    height: 16px;\n    margin-right: 10px;\n}\n\n.popover_item_text {\n    font-size: 14px;\n}\n\n:global(.custom_popover_collect .ant-popover-content .ant-popover-inner) {\n    padding: 5px;\n}\n\n.tool_collect {\n    background: url('../../../../statics/collect_mark.png') no-repeat center / 100% 100%;\n}\n\n/* 隐藏伪元素用来预加载悬停背景图 */\n.tool_collect::before {\n    content: \"\";\n    background: url('../../../../statics/collect_mark_hover.png') no-repeat center / 100% 100%;\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    z-index: -1;\n}\n\n.tool_collect::after {\n    content: \"\";\n    background: url('../../../../statics/collect_mark_active.png') no-repeat center / 100% 100%;\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    z-index: -1;\n}\n\n.tool_collect:hover {\n    background: url('../../../../statics/collect_mark_hover.png') no-repeat center / 100% 100%;\n    box-shadow:0px 5px 10px #ddd;\n}\n\n.tool_collect:active {\n    background: url('../../../../statics/collect_mark_active.png') no-repeat center / 100% 100%;\n    box-shadow:0px 5px 10px #ddd;\n}\n\n.ask_abstract_box {\n    width: 70%;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n/* .ask_abstract {\n    width: 100%;\n    height: 100%;\n    font-family: 'PingFangSCMedium';\n    font-size: 16px;\n    color: #4f4f4f;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n} */\n\n.ask_list_item {\n    width: 100%;\n    /* min-height: 56px; */\n    padding: 15px;\n    /* overflow: hidden; */\n    overflow: visible;\n    transition: height 0.4s;\n}\n\n.ask_item_top {\n    display: flex;\n    align-items: flex-start;\n    width: 100%;\n}\n\n.ask_item_top_open {\n    align-items: flex-start;\n}\n\n.ask_vector_box,\n.ask_vector_open_box {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: 32px;\n    height: 42px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n    flex-shrink: 0; /* 防止被压缩 */\n    padding-top: 10px;\n}\n\n.ask_model_img {\n    width: 28px;\n    height: 28px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    font-size: 14px;\n    color: #4f4f4f;\n    flex-shrink: 0; /* 防止被压缩 */\n}\n\n.ask_vector_open_box {\n    justify-content: flex-end;\n    align-items: flex-start;\n}\n\n.ask_tool_box {\n    display: flex;\n    justify-content: flex-end;\n    width: 24%;\n    flex-shrink: 0; /* 防止被压缩 */\n    padding-top: 10px;\n}\n\n.ask_abstract {\n    max-height: 60px;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-line-clamp: 2; /* 限制显示两行 */\n    -webkit-box-orient: vertical;\n    text-overflow: ellipsis; /* 超出部分显示省略号 */\n    flex-grow: 1;\n    transition: max-height .3s ease;\n}\n\n.ask_abstract.expanded {\n  -webkit-line-clamp: unset; /* 取消行数限制 */\n  max-height: none;\n    white-space: normal;\n}\n\n.ask_abstract.collapsed {\n    display: -webkit-box;\n    -webkit-line-clamp: 2; /* 限制显示两行 */\n    -webkit-box-orient: vertical;\n    text-overflow: ellipsis; /* 超出部分显示省略号 */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ShowBox_container__QsIUh`,
	"main": `ShowBox_main__HeYYw`,
	"filter_box": `ShowBox_filter_box__UX1j5`,
	"filter_title": `ShowBox_filter_title__O3PMc`,
	"filter_hint": `ShowBox_filter_hint__QnrzL`,
	"list_box": `ShowBox_list_box__3kuPG`,
	"list_item_box": `ShowBox_list_item_box__BHcGj`,
	"list_item": `ShowBox_list_item__NTJGq`,
	"list_item_open": `ShowBox_list_item_open__YZ9QM`,
	"item_top": `ShowBox_item_top__mtPK2`,
	"vector_box": `ShowBox_vector_box__3rC0c`,
	"vector_open_box": `ShowBox_vector_open_box__SyLZ-`,
	"vector_drag": `ShowBox_vector_drag__2uaTU`,
	"vector_message": `ShowBox_vector_message__ptitK`,
	"vector_open": `ShowBox_vector_open__F6RiG`,
	"abstract_box": `ShowBox_abstract_box__g0VSy`,
	"abstract": `ShowBox_abstract__-isLY`,
	"tool_box": `ShowBox_tool_box__6EZDO`,
	"tool_enter": `ShowBox_tool_enter__3I5tz`,
	"tool_delete": `ShowBox_tool_delete__cqABH`,
	"tool_collect": `ShowBox_tool_collect__zQMg-`,
	"tool_more": `ShowBox_tool_more__qfP8N`,
	"time": `ShowBox_time__vGPoZ`,
	"item_bottom": `ShowBox_item_bottom__hBj1X`,
	"model_box": `ShowBox_model_box__7NzZa`,
	"model_img": `ShowBox_model_img__cvOZl`,
	"model_name": `ShowBox_model_name__g-2Rv`,
	"num_box": `ShowBox_num_box__cf-hW`,
	"text_box": `ShowBox_text_box__j0Bwv`,
	"text_title": `ShowBox_text_title__TYHEq`,
	"text_img": `ShowBox_text_img__8voWM`,
	"num": `ShowBox_num__Owj7-`,
	"popover_box": `ShowBox_popover_box__IEDdg`,
	"popover_item": `ShowBox_popover_item__ZLax0`,
	"popover_butn_img": `ShowBox_popover_butn_img__Rrds8`,
	"popover_item_text": `ShowBox_popover_item_text__qpPil`,
	"ask_abstract_box": `ShowBox_ask_abstract_box__iOG1d`,
	"ask_list_item": `ShowBox_ask_list_item__12EoS`,
	"ask_item_top": `ShowBox_ask_item_top__3qpJn`,
	"ask_item_top_open": `ShowBox_ask_item_top_open__JujVB`,
	"ask_vector_box": `ShowBox_ask_vector_box__TQwJi`,
	"ask_vector_open_box": `ShowBox_ask_vector_open_box__GLoXh`,
	"ask_model_img": `ShowBox_ask_model_img__jQcCJ`,
	"ask_tool_box": `ShowBox_ask_tool_box__lAoHL`,
	"ask_abstract": `ShowBox_ask_abstract__VZILU`,
	"expanded": `ShowBox_expanded__BqWR3`,
	"collapsed": `ShowBox_collapsed__83Vyx`
};
export default ___CSS_LOADER_EXPORT___;
